import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestApi } from '../../auth/rest.api';
import { IFacadeTableDescriptor } from 'app/core/typings/IFacadeTableDescriptor';
import { IFacadeExportObject } from 'app/core/typings/IFacadeExportObject';
import { ISyncDataService } from 'app/core/typings/ISyncDataServices';
import { ISyncDataObject } from 'app/core/typings/ISyncDataObject';
import { ISyncDataExportFile } from 'app/core/typings/ISyncDataExportFile';
import { ISyncDataImportFile } from 'app/core/typings/ISyncDataImportFile';

@Injectable({
  providedIn: 'root'
})
export class SyncDataService implements ISyncDataService {

  _filePath: string;
  _overrideTargetResources: boolean;

  constructor(private _authHttp: RestApi) { }

  public getTables(): Promise<IFacadeExportObject> {
    return this.getAvailableTables().then((data: ISyncDataObject) => {

      if (data.ErrorLog) {
        throw new Error(data.ErrorLog);
      }
      return Promise.resolve(data.SyncDataContent);
    });
  }

  public getImportTables(fileToImport: File): Promise<IFacadeExportObject> {
    return this.getImportFile(fileToImport).then((data: ISyncDataObject) => {

      if (data.ErrorLog) {
        throw new Error(data.ErrorLog);
      }

      this.addUserTableToEntityTableInImport(data.SyncDataContent.EntityTables, data.SyncDataContent.UsersAvailable);
      return Promise.resolve(data.SyncDataContent);
    });
  }

  public export(objectToExport: IFacadeExportObject) {
    const url = 'api/syncdata/export/validate-export';
    return this._authHttp.requestBlob({ body: objectToExport, url, parameters: [] }, 'POST').toPromise();
  }

  public validateImport(syncData: IFacadeExportObject): Promise<ISyncDataObject> {
    const url = 'api/syncdata/import/validate-import';

    return this._authHttp.post(url, syncData)
        .toPromise()
        .then(response => {
          return Promise.resolve(response as ISyncDataObject);
        })
      .catch(this.handleError);
  }

  public getFileFromTableStorage(partitionKey: string, rowKey: string): Promise<any> {
    const url = 'api/syncdata/export/generate-file-storage';
    const rawJson = `{ "partitionKey":"`+ partitionKey +`",
      "rowKey":"`+ rowKey +`" }`;

    return this._authHttp.post(url, JSON.parse(rawJson), {responseType:'arraybuffer'})
      .toPromise()
      .then(response => Promise.resolve(response))
      .catch(this.handleError);
  }

  public executeImport(syncData: IFacadeExportObject): Promise<any> {
    const url = 'api/syncdata/import/execute-import';
    return this._authHttp.post(url, syncData)
      .toPromise()
      .then(response => Promise.resolve(response))
      .catch(this.handleError);
  }

  public isBizagiAuthenticationType(): Promise<any> {
    const url = 'api/syncdata/import/get-authentication-type/';
    return this._authHttp.get(url)
      .toPromise()
      .then(response => response as string)
      .catch(this.handleError);
  }


  public orderEntityList(list: IFacadeTableDescriptor[]): IFacadeTableDescriptor[] {
    list = _.sortBy(list, ['DisplayName']);
    return list;
  }

  public getHistoryExportedFiles(): Promise<ISyncDataExportFile[]> {
    const url = 'api/syncdata/export/history';
    return this._authHttp.get(url)
      .toPromise()
      .then(response => {
        const httpResponse = response as ISyncDataExportFile[];
        return Promise.resolve(httpResponse);
      })
      .catch(this.handleError);
  }

  public getHistoryImportedFiles(): Promise<ISyncDataImportFile[]> {
    const url = 'api/syncdata/import/history';
    return this._authHttp.get(url)
      .toPromise()
      .then(response => {
        const httpResponse = response as ISyncDataImportFile[];
        return Promise.resolve(httpResponse);
      })
      .catch(this.handleError);
  }

  public getImportStatusFile(): Promise<string> {
    const url = 'api/syncdata/import/status';
    return this._authHttp.get(url)
      .toPromise()
      .then(response => {
        const httpResponse = response as string;
        return Promise.resolve(httpResponse);
      })
      .catch(this.handleError);
  }

  private getAvailableTables(): Promise<ISyncDataObject> {
    const url = 'api/syncdata/export/get-export-file';

    return this._authHttp.get(url)
      .toPromise()
      .then(response => {
        const httpResponse = response as ISyncDataObject;
        return Promise.resolve(httpResponse);
      })
      .catch(this.handleError);
  }

  private getImportFile(file: File): Promise<ISyncDataObject> {
    const url = 'api/syncdata/import/get-import-file';
    const formData: FormData = new FormData();
    formData.append('file', file);

    return this._authHttp.postFile(url, formData)
      .toPromise()
      .then(response => {
        const httpResponse = response as ISyncDataObject;
        return Promise.resolve(httpResponse);
      })
      .catch(this.handleError);
  }

  private addUserTableToEntityTableInImport(entityTables: IFacadeTableDescriptor[], showUsers: boolean) {
    if (showUsers) {
      let wfuserTable : IFacadeTableDescriptor;
      wfuserTable = {
        DisplayName: 'Users',
        Selected: true,
        SelectedUI: false,
        TableName: 'WFUSER',
        EntityKeysSource: null,
      };
      if (!entityTables){
        entityTables = new Array<IFacadeTableDescriptor>();
      }
      entityTables.push(wfuserTable);
    }
  }

  private handleError(error: any): Promise<any> {
    let messageKey: string;

    switch(error.status)
    {
      case 415:
      messageKey = 'GLOBAL.INVALID_FILE';
      break;
      default:
      messageKey = 'GLOBAL.AN_ERROR_HAS_OCCURRED'
      break;

    }
    return Promise.reject(messageKey);
  }

}
